import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../constants/common'
import Button from '../../../Button'
import { useDocFlowContext } from '../../DocFlow.hooks'
import { DocFlowProfileHeaderActionsBase } from '../DocFlowProfileHeaderActionsBase'

import { QA_NAME_ADD_RECIPIENT_BTN } from './DocFlowProfileHeaderActionsCombining.constants'

function DocFlowProfileHeaderActionsCombining({
  addRecipientDisabled,
  completedPhase,
  nextPhaseDisabled,
  onClickAddRecipientBtn,
  ...restProps
}) {
  const { t } = useTranslation()

  const {
    docFlow: {
      has_combinings_with_empty_documents: hasCombiningsWithEmptyDocuments,
      has_multiply_uploadings: hasMultiplyUploadings,
    } = EMPTY_OBJECT,
  } = useDocFlowContext()

  const nextPhaseBtnTooltip = nextPhaseDisabled
    ? 'DocumentStapling.CombiningPhaseNextPhaseDisabledBtnTooltipKey'
    : hasCombiningsWithEmptyDocuments
      ? 'DocFlow.CombiningPhaseSplittedDocumentsNullNextPhaseDisabledBtnTooltipKey'
      : null

  return (
    <DocFlowProfileHeaderActionsBase
      {...restProps}
      completedPhase={completedPhase}
      nextButtonProps={{
        nextPhaseDisabled: nextPhaseDisabled || hasCombiningsWithEmptyDocuments,
        tooltip: nextPhaseBtnTooltip,
      }}
      nextPhaseModalDescription='DocumentStapling.CombiningPhaseAttentionModalNextPhaseTextKey'
    >
      {hasMultiplyUploadings ? (
        <Button.Outlined
          disabled={addRecipientDisabled || completedPhase}
          qaName={QA_NAME_ADD_RECIPIENT_BTN}
          text={t('DocumentStapling.AddRecipientBtnKey')}
          type='button'
          onClick={onClickAddRecipientBtn}
        />
      ) : null}
    </DocFlowProfileHeaderActionsBase>
  )
}

export default DocFlowProfileHeaderActionsCombining
